export default __webpack_public_path__ + "static/media/04_mother.be211387.png";